module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.1cfd4223e7c48a764232.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/dani/apps/WebTerminalEN/src/assets/Theme/fonts/glyphicons-halflings-regular.ttf
// module id = ../../../../../src/assets/Theme/fonts/glyphicons-halflings-regular.ttf
// module chunks = 1